import * as yup from 'yup'

const validationSchema = yup.string().trim().max(1000).required()

export default validationSchema
